import React from "react";
import { House, MessageCircle, ChartNoAxesCombined, User } from "lucide-react";

const tabs = [
  {
    id: "home",
    label: "Home",
    render: (active) => (
      <House
        size={20}
        strokeWidth={2}
        style={{
          color: active ? "#F7EEDA" : "rgba(247,238,218,0.92)",
          transition: "transform 0.28s ease, opacity 0.28s ease",
          transform: active ? "translateY(-1px)" : "translateY(0)",
        }}
      />
    ),
  },
  {
    id: "chat",
    label: "Chat",
    render: (active) => (
      <MessageCircle
        size={20}
        strokeWidth={2}
        style={{
          color: active ? "#F7EEDA" : "rgba(247,238,218,0.92)",
          transition: "transform 0.28s ease, opacity 0.28s ease",
          transform: active ? "translateY(-1px)" : "translateY(0)",
        }}
      />
    ),
  },
  {
    id: "insights",
    label: "Insights",
    render: (active) => (
      <ChartNoAxesCombined
        size={19}
        strokeWidth={2.1}
        style={{
          color: active ? "#F7EEDA" : "rgba(247,238,218,0.92)",
          transition: "transform 0.28s ease, opacity 0.28s ease",
          transform: active ? "translateY(-1px)" : "translateY(0)",
        }}
      />
    ),
  },
  {
    id: "profile",
    label: "Profile",
    render: (active) => (
      <User
        size={20}
        fill={active ? "#F7EEDA" : "rgba(247,238,218,0.92)"}
        strokeWidth={1.7}
        style={{
          color: active ? "#F7EEDA" : "rgba(247,238,218,0.92)",
          transition: "transform 0.28s ease, opacity 0.28s ease",
          transform: active ? "translateY(-1px)" : "translateY(0)",
        }}
      />
    ),
  },
];

export const BottomTabs = ({ activeTab, onTabChange }) => {
  return (
    <nav
      data-testid="bottom-tabs"
      className="fixed inset-x-0 bottom-0 z-50 flex justify-center px-4"
      style={{
        paddingBottom: "calc(10px + env(safe-area-inset-bottom, 0px))",
        pointerEvents: "none",
      }}
    >
      <div
        className="flex w-full max-w-[11.25rem] items-center justify-between rounded-full px-2 py-1"
        style={{
          minHeight: "34px",
          background: "rgba(20,20,20,0.94)",
          border: "1px solid rgba(255,255,255,0.07)",
          boxShadow: "0 14px 28px rgba(0,0,0,0.32), inset 0 1px 0 rgba(255,255,255,0.05)",
          backdropFilter: "blur(14px)",
          WebkitBackdropFilter: "blur(14px)",
          pointerEvents: "auto",
        }}
      >
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              data-testid={`bottom-tab-${tab.id}`}
              aria-label={tab.label}
              onClick={() => onTabChange(tab.id)}
              className="relative flex h-7 w-7 items-center justify-center rounded-full"
              style={{
                WebkitTapHighlightColor: "transparent",
                transition: "transform 0.25s ease, opacity 0.25s ease",
                opacity: isActive ? 1 : 0.86,
                transform: isActive ? "translateY(-1px)" : "translateY(0)",
              }}
            >
              {tab.render(isActive)}
              {isActive && (
                <span
                  aria-hidden="true"
                  className="absolute -bottom-[1px] h-1 w-1 rounded-full"
                  style={{
                    background: "#F7EEDA",
                    boxShadow: "0 0 8px rgba(247,238,218,0.88)",
                  }}
                />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomTabs;
